import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [vendor, setVendor] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('vendor_token');
    if (token) {
      fetchVendorProfile(token);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchVendorProfile = async (token) => {
    try {
      const response = await axios.get(`${API}/vendor/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setVendor(response.data);
    } catch (error) {
      localStorage.removeItem('vendor_token');
    } finally {
      setLoading(false);
    }
  };

  const vendorLogin = async (identifier, password) => {
    const response = await axios.post(`${API}/vendor/login`, { identifier, password });
    localStorage.setItem('vendor_token', response.data.token);
    setVendor(response.data.vendor);
    return response.data;
  };

  const vendorSignup = async (email, password, business_name, phone) => {
    const response = await axios.post(`${API}/vendor/signup`, {
      email,
      password,
      business_name,
      phone: phone || undefined,
    });
    localStorage.setItem('vendor_token', response.data.token);
    setVendor(response.data.vendor);
    return response.data;
  };

  const vendorLogout = () => {
    localStorage.removeItem('vendor_token');
    setVendor(null);
  };

  const customerLogin = (token, email) => {
    localStorage.setItem('customer_token', token);
    setCustomer({ email });
  };

  const customerLogout = () => {
    localStorage.removeItem('customer_token');
    setCustomer(null);
  };

  return (
    <AuthContext.Provider
      value={{
        vendor,
        customer,
        loading,
        vendorLogin,
        vendorSignup,
        vendorLogout,
        refreshVendor: () => fetchVendorProfile(localStorage.getItem('vendor_token')),
        customerLogin,
        customerLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
